import { render, staticRenderFns } from "./VaPageNotFoundSimple.vue?vue&type=template&id=1c4d2290"
import script from "./VaPageNotFoundSimple.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundSimple.vue?vue&type=script&lang=js"
import style0 from "./VaPageNotFoundSimple.vue?vue&type=style&index=0&id=1c4d2290&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports